import { render, staticRenderFns } from "./LeaderboardList.vue?vue&type=template&id=56dc08dc&"
import script from "./LeaderboardList.vue?vue&type=script&lang=js&"
export * from "./LeaderboardList.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports